import { z } from "zod";
import { type IntlShape } from "react-intl";

export const corrugateSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	alias: z.string(),
	width: z.number(),
	thickness: z.number(),
	quality: z.number(),
	flute: z.string(),
});

export const corrugateBrandSchema = z.object({
	brand: z.number(),
});

export const getCorrugateConfigurationSchema = (intl: IntlShape) =>
	z.object({
		alias: z
			.string(intl.formatMessage({ id: "Alias needs to be a string", defaultMessage: "Alias needs to be a string" }))
			.trim()
			.nonempty(intl.formatMessage({ id: "Alias can not be empty", defaultMessage: "Alias can not be empty" })),
		width: z
			.number(intl.formatMessage({ id: "Width needs to be a number", defaultMessage: "Width needs to be a number" }))
			.multipleOf(
				0.0001,
				intl.formatMessage({
					id: "Width must be a multiple of 0.0001",
					defaultMessage: "Width must be a multiple of 0.0001",
				}),
			)
			.positive(
				intl.formatMessage({
					id: "Width must be a positive number",
					defaultMessage: "Width must be a positive number",
				}),
			),
		thickness: z.number(),
		quality: z
			.number(intl.formatMessage({ id: "Brand needs to be a number", defaultMessage: "Brand needs to be a number" }))
			.nonnegative(
				intl.formatMessage({
					id: "Brand must be a positive number",
					defaultMessage: "Brand must be a positive number",
				}),
			),
		flute: z
			.string(intl.formatMessage({ id: "Flute needs to be a string", defaultMessage: "Flute needs to be a string" }))
			.trim()
			.nonempty(intl.formatMessage({ id: "Flute can not be empty", defaultMessage: "Flute can not be empty" })),
	});

export type Corrugate = z.infer<typeof corrugateSchema>;
export type CorrugateBrand = z.infer<typeof corrugateBrandSchema>;
export type CorrugateConfiguration = z.infer<ReturnType<typeof getCorrugateConfigurationSchema>>;
